<div class="modal-header border-0">
  <button
    class="btn-close"
    (click)="modal.dismiss()"
    gptDataTrack="connect-device-modal-close"
  >
    <i class="gpicon-close"></i>
  </button>
</div>
<div class="custom-scroll-parent gp-sm-8">
  <ng-container *ngIf="!showQr; else qrView">
    <div class="modal-body custom-scroll gpx-sm-64 gpy-56 text-center">
      <img
        [src]="'/assets/images/wearables/' + platformImg"
        alt="connect app"
        class="gmt-48 gmt-sm-0"
      />
      <h4 class="h4-bold gmb-24 gmt-16">
        {{ 'WEARABLES.BROWSER.CONNECT_APP.TITLE' | translate }}
      </h4>
      <p class="p3-regular text-secondary mb-0">
        {{ 'WEARABLES.BROWSER.CONNECT_APP.TEXT' | translate }}
      </p>

      <app-form-page-footer>
        <div class="d-flex justify-content-center">
          <button
            class="gbtn-1 gbtn-sq b2-semibold gmt-32"
            [ngClass]="'' | gpuMediaQuery: 'w-100'"
            (click)="toggleQrView()"
            gptDataTrack="connect-device-modal-confirm"
          >
            {{ 'WEARABLES.BROWSER.CONNECT_APP.BUTTON' | translate }}
          </button>
        </div>
      </app-form-page-footer>
    </div>
  </ng-container>
</div>

<ng-template #qrView>
  <div
    class="modal-body custom-scroll d-flex align-items-center justify-content-center gpx-sm-64 gpy-56"
  >
    <!-- DESKTOP -->
    <div class="d-none d-sm-block">
      <div class="text-center">
        <img src="/assets/images/wearables/qr-code.svg" alt="qr code" />
      </div>
      <h4 class="h4-bold mb-0 text-center">
        {{ 'WEARABLES.BROWSER.CONNECT_APP.SCAN' | translate }}
      </h4>
      <p class="p4-regular gmt-16 mb-0 text-center text-secondary">
        {{ 'WEARABLES.BROWSER.CONNECT_APP.POINT' | translate }}
      </p>
      <div class="gmy-40 text-center">
        <ng-container *ngTemplateOutlet="googlePlay"></ng-container>
        <ng-container *ngTemplateOutlet="appStore"></ng-container>
      </div>
    </div>

    <!-- MOBILE -->
    <div class="d-sm-none text-center">
      <h4 class="h4-bold gmb-24 text-center">
        {{ 'WEARABLES.BROWSER.CONNECT_APP.DOWNLOAD' | translate }}
      </h4>
      <div>
        <img
          src="/assets/images/wearables/device-dashboard.svg"
          alt="Device dashboard"
        />
      </div>
      <div class="gmt-24">
        <ng-container
          *ngIf="isPlatformAndroid(); then googlePlay"
        ></ng-container>
        <ng-container *ngIf="isPlatformIOS(); then appStore"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #googlePlay>
  <a
    href="https://play.google.com/store/apps/details?id=com.geneplanet.app"
    target="_blank"
    class="d-inline-block gmx-16"
    gptDataTrack="connect-device-modal-android"
  >
    <i class="svg-google-play svg-google-play-dims d-block"></i>
  </a>
</ng-template>

<ng-template #appStore>
  <a
    href="https://apps.apple.com/si/app/geneplanet/id1500258339"
    target="_blank"
    class="d-inline-block gmx-16"
    gptDataTrack="connect-device-modal-ios"
  >
    <i class="svg-app-store svg-app-store-dims d-block"></i>
  </a>
</ng-template>
